import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0698a474"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row row-settings" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_6 = { class: "pb-2" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_9 = { class: "selector-content" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_SelectedProduct = _resolveComponent("SelectedProduct")!
  const _component_ProductSelectorCriteria = _resolveComponent("ProductSelectorCriteria")!
  const _component_ProductSelectorList = _resolveComponent("ProductSelectorList")!
  const _component_FloatingPanel = _resolveComponent("FloatingPanel")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_ctx.rootClass)
  }, [
    (_ctx.singleProduct)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (!_ctx.selectedProduct)
                ? (_openBlock(), _createBlock(_component_InputText, {
                    key: 0,
                    modelValue: _ctx.catalogProductsCriteria.search_keyword,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.catalogProductsCriteria.search_keyword) = $event)),
                    name: "product_input",
                    label: _ctx.$t('product'),
                    rules: "max:255",
                    class: "col-6",
                    "can-clear": "",
                    errors: _ctx.errors,
                    onInput: _ctx.handleKeyWordInput
                  }, null, 8, ["modelValue", "label", "errors", "onInput"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.selectedProduct)
            ? (_openBlock(), _createBlock(_component_SelectedProduct, {
                key: 0,
                product: _ctx.selectedProduct,
                onSelectionRemoved: _ctx.removeSelection
              }, null, 8, ["product", "onSelectionRemoved"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: _normalizeClass(`btn btn-icon btn-primary ${_ctx.buttonClass}`),
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openMultiSelectSearch && _ctx.openMultiSelectSearch(...args)), ["prevent"]))
        }, _hoisted_4, 2)),
    (_openBlock(), _createBlock(_component_FloatingPanel, {
      visible: _ctx.isSelecting,
      "max-height": 700,
      "min-height": 600,
      key: _ctx.panelKey
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (!_ctx.advancedSearch)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.switchToAdvancedSearch && _ctx.switchToAdvancedSearch(...args)))
                }, _toDisplayString(_ctx.$t('advancedSearch')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "aria-label": "Close",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closePanel && _ctx.closePanel(...args)))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.advancedSearch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_ProductSelectorCriteria, {
                  modelValue: _ctx.catalogProductsCriteria,
                  "onUpdate:modelValue": [
                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.catalogProductsCriteria) = $event)),
                    _ctx.doAdvancedSearch
                  ]
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.listAndSelectClass)
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ProductSelectorList, {
                "single-product": _ctx.singleProduct,
                "products-overview": _ctx.catalogProducts,
                errors: _ctx.errors,
                ready: _ctx.selectorUI.isReady(),
                modelValue: _ctx.selectedProducts,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedProducts) = $event)),
                onSelectSingleProduct: _ctx.selectSingleProduct,
                onSelectProducts: _ctx.selectProducts
              }, null, 8, ["single-product", "products-overview", "errors", "ready", "modelValue", "onSelectSingleProduct", "onSelectProducts"])
            ]),
            (!_ctx.singleProduct && _ctx.catalogProducts.results?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.selectProductsFromModel && _ctx.selectProductsFromModel(...args)))
                  }, _toDisplayString(_ctx.$t('select')), 1)
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _: 1
    }, 8, ["visible"]))
  ], 2))
}